import { axiosNoAuth } from '../../config/axios-instances';
import { ADMIN_API } from '../../config/config';
import { Api_url } from '../../config/api_url';

export function createPopQuiz(data, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosNoAuth.post(ADMIN_API + Api_url.CreatePopQuiz, data);
            successCallback && successCallback(response.data.data);
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err.response.data)
        }
    }
}